import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { PrimengModule } from '../primeng/primeng.module';
import { HttpLoaderFactory } from './language';

export const COMMON_MODULES = [
  CommonModule,
  PrimengModule,
  TranslateModule.forChild({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
  }),
];
